import axios from 'axios';

/**
 * Fügt Authorization-Header Interceptor hinzu
 * @param {import('axios').AxiosInstance} axiosInstance
 */
export function addAuthInterceptor(axiosInstance) {
  axiosInstance.interceptors.request.use(
    config => {
      if (axios.defaults.headers.Authorization) {
        config.headers.Authorization = axios.defaults.headers.Authorization;
      }
      return config;
    },
    error => Promise.reject(error)
  );
}

/**
 * Fügt Error-Handling Interceptor hinzu
 * @param {import('axios').AxiosInstance} axiosInstance
 * @param {any} fallbackData - Fallback-Daten bei Fehler
 */
export function addErrorInterceptor(axiosInstance, fallbackData = []) {
  axiosInstance.interceptors.response.use(
    response => response,
    error => {
      if (error.response?.status === 404) {
        console.warn('Resource not found, using fallback data');
        return { data: fallbackData };
      }
      if (error.response?.status === 401) {
        console.error('Unauthorized');
        return { data: fallbackData };
      }
      throw error;
    }
  );
}
